import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster,
  InputNumber
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataPtech {
  id: string; // or number, depending on your data
  attributes: {
    PTechcode: string;
    PTechName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const PTechNameMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  ////////////////  Function For 10 Start /////////////////
  const [ptech, setPtech] = useState({
    PTechName: '',
    PTechcode: '',
    dis: 'Continue'
  });

  // Fetch Data from API Start
  const [ptechdata, setPtechdata] = useState<RowDataPtech[]>([]);
  const [ptechmeta, setPtechmeta] = useState<MetaData>();
  const [disMST, setDisMST] = useState([]);
  const [editedRowIdsPtech, setEditedRowIdsPtech] = useState<string[]>([]);
  const [editedRowIdPtech, setEditedRowIdPtech] = useState<string>('');
  const [editedDataPtech, setEditedDataPtech] = useState<
    Record<string, Partial<RowDataPtech['attributes']>>
  >({});
  const [selectedBuyerptech, setSelectedBuyerptech] = useState('Continue');
  const handleBuyerChangeptech = value => {
    setSelectedBuyerptech(value);
  };
  const [isLoading10, setIsLoading10] = useState(false);
  useEffect(() => {
    fetchData10();
  }, [selectedBuyerptech]);
  const fetchData10 = async () => {
    if (isLoading10) {
      return;
    }
    setIsLoading10(true);
    let disFilter = '';
    if (selectedBuyerptech.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyerptech}`;
    }
    if (selectedBuyerptech == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/mst-ptechniques?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mst-ptechniques?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mst-ptechniques?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(
      `${globalIP}/api/mst-ptechniques`
    );
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mst-ptechniques?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);

    }
    setDisMST(allData2)
    setPtechmeta(jsonmeta.meta);
    setPtechdata(allData);
    setIsLoading10(false);
  };
  const processInputRef = useRef(null);
  const handleEditRowPtech = rowData => {
    setPtech({ ...rowData.attributes });
    setEditedRowIdPtech(rowData.id)
    setEditedRowIdsPtech(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataPtech(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetPtech = () => {
    setPtech({
      PTechName: '',
      PTechcode: '',
      dis: 'Continue'
    });
  };
  const handleCancelPtech = rowData => {
    resetPtech();
    setEditedRowIdPtech('');
    setEditedRowIdsPtech('');
  };


  // const generateNextCategoryCode10 = () => {
  //   const nextCode = ptechmeta?.pagination?.total + 1;
  //   return `PTEC-${nextCode.toString().padStart(3, '0')}`;
  // };
  // let nextCategoryCode10 = generateNextCategoryCode10();
  const url10 = `${globalIP}/api/mst-ptechniques`;
  const submit10 = async e => {
    e.preventDefault(); // Ensure the default form submission is prevented at the start
    const trimmedPtech = ptech.PTechName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>?+=*&^%$#@!~`()\\]/;


    // Validate the input
    if (!trimmedPtech) {
      toaster.push(
        <Message showIcon type="error">
          Please enter a valid {label[0]?.attributes.P_Technique}.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Exit if validation fails
    }

    if (specialCharPattern.test(trimmedPtech)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.P_Technique} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Exit if validation fails
    }
    try {
      const { data: pNamee } = await axios.get(
        `${globalIP}/api/mst-ptechniques?filters[PTechName][$eqi]=${trimmedPtech}`
      );
      const { data: pNameCode } = await axios.get(`${globalIP}/api/mst-ptechniques?populate=*`);
      const nextCode = pNameCode.meta.pagination.total + 1;

      if (pNamee.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.P_Technique} {ptech.PTechName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit if validation fails
      }

      // Generate the next category code
      // const nextCategoryCode = generateNextCategoryCode10();

      // Prepare the form data for submission
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({ ...ptech, PTechName: trimmedPtech, PTechcode: `PTEC-${nextCode.toString().padStart(3, '0')}` })
      );

      // Send the POST request
      const response = await fetch(url10, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData10(); // Refresh data after successful save
        toaster.push(
          <Message showIcon type="success">
            Data saved successfully.
          </Message>,
          { placement: 'topCenter' }
        );
        // Clear the form
        setPtech({
          PTechName: '',
          PTechcode: '',
          dis: 'Continue'
        });
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred during submission:', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving data. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  //  Fetch Data from API End
  const handleInputChange10 = (inputName, value, index) => {
    setPtech({ ...ptech, [inputName]: value });
  };
  const handlePtechc = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...ptechdata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mst-ptechniques/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData10();
        toaster.push(
          <Message showIcon type="success">
            {mat} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handlePtechD = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...ptechdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mst-ptechniques/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData10();
        toaster.push(
          <Message showIcon type="success">
            {mat} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowPtech = async () => {
    try {
      // Find the row data by ID
      // const rowData = ptechdata.find(row => row.id === rowId);
      if (!ptech) {
        console.error('Row data not found.');
        return; // Exit if the row data is not found
      }

      // Trim and validate the updated PTechName
      // const updatedCategoryName = editedDataPtech[rowId]?.PTechName?.trim();
      const updatedCategoryName = ptech?.PTechName?.trim() || '';
      const specialCharPattern = /[{}\[\];:"'|<,>?+=*&^%$#@!~`()\\]/;


      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid {label[0]?.attributes.P_Technique}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      // Check for special characters in the updated name
      if (specialCharPattern.test(updatedCategoryName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.P_Technique} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      const { data: updatePTechName } = await axios.get(
        `${globalIP}/api/mst-ptechniques?filters[PTechName][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowIdPtech}`
      );
      if (updatePTechName.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.P_Technique} {updatedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // Prepare the updated row data
      // const updatedRowData: RowDataPtech = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataPtech[rowId],
      //     PTechName: updatedCategoryName
      //   }
      // };

      // Send the PUT request to update the data
      const response = await fetch(`${globalIP}/api/mst-ptechniques/${editedRowIdPtech}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...ptech, PTechName: updatedCategoryName } })
      });

      // Check the response status
      if (response.ok) {
        await fetchData10(); // Refresh data after successful update
        resetPtech();
        setEditedRowIdPtech('');
        setEditedDataPtech(prevData => ({
          ...prevData,
          [editedRowIdPtech]: { ...ptech, PTechName: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIdsPtech(prevRowIds => [...new Set([...prevRowIds, editedRowIdPtech])]);
        toaster.push(
          <Message showIcon type="success">
            {label[0]?.attributes.P_Technique} updated successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        // Handle error response
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving data. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const handleSaveRowPtech1 = async (rowId: string) => {
    try {
      // Find the row data by ID
      const rowData = ptechdata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return; // Exit if the row data is not found
      }

      // Trim and validate the updated PTechName
      const updatedCategoryName = editedDataPtech[rowId]?.PTechName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>?+=*&^%$#@!~`()\\]/;


      const { data: updatePTechName } = await axios.get(
        `${globalIP}/api/mst-ptechniques?filters[PTechName][$eqi]=${updatedCategoryName}&filters[id][$ne]=${rowId}`
      );
      // Check for special characters in the updated name
      if (specialCharPattern.test(updatedCategoryName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.P_Technique} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      const existingHscode = ptechdata.find(
        item => item.attributes.PTechName.toLowerCase() === updatedCategoryName.toLowerCase()
      );
      if (updatePTechName.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.P_Technique} {updatedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // Prepare the updated row data
      const updatedRowData: RowDataPtech = {
        ...rowData,
        attributes: {
          ...rowData.attributes,
          ...editedDataPtech[rowId],
          PTechName: updatedCategoryName
        }
      };

      // Send the PUT request to update the data
      const response = await fetch(`${globalIP}/api/mst-ptechniques/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });

      // Check the response status
      if (response.ok) {
        await fetchData10(); // Refresh data after successful update
        setEditedRowIdsPtech(prevRowIds => prevRowIds.filter(id => id !== rowId));
        toaster.push(
          <Message showIcon type="success">
            {label[0]?.attributes.P_Technique} updated successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        // Handle error response
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving data. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const handleInputChangePtech = (rowId, fieldName, value) => {
    setEditedDataPtech(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...ptechdata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 10 End /////////////////
  ////////////////  Searching For 10 Start /////////////////
  const [searchQuery10, setSearchQuery10] = useState('');
  const [filterStatus10, setFilteredStatus10] = useState('Continue');
  const handleSearch10 = value => {
    setSearchQuery10(value);
  };
  const [ptechFilterData, setPtechFilterData] = useState([])

  useEffect(() => {
    const ptechFilterData = ptechdata
      .slice()
      .reverse()
      .filter(item => {
        const PtechName = item.attributes.PTechName
          ? item.attributes.PTechName.toLowerCase()
          : '';
        return PtechName.includes(searchQuery10.toLowerCase());
      })
    setPtechFilterData(ptechFilterData)
  }, [ptechdata, filterStatus10, searchQuery10])
  ////////////////  Searching For 10 End /////////////////
  return (
    <>
      <Form.ControlLabel>
        <b>{label[0]?.attributes.P_Technique}</b>
      </Form.ControlLabel>
      <Stack
        justifyContent="space-between"
        style={{ marginBottom: '10px' }}
        className="mstr-panel"
      >
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="PTechName"
            name="PTechName"
            style={{ width: '180%' }}
            autoComplete="off"
            ref={processInputRef}
            value={ptech && ptech.PTechName ? ptech.PTechName : ''}
            onChange={value => handleInputChange10('PTechName', value, 0)}
            onPressEnter={submit10}
          />
          {editedRowIdPtech ? (
            <Button appearance="primary" color="cyan" onClick={handleSaveRowPtech} className="mstr-btn" style={{ marginLeft: "10px" }}>
              Update
            </Button>) : (
            <Button appearance="primary" color="cyan" onClick={submit10} className="mstr-btn" style={{ marginLeft: "10px" }}>
              Add
            </Button>)}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginLeft: "7px" }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyerptech}
            onChange={handleBuyerChangeptech}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input
              placeholder="Search"
              type="text"
              value={searchQuery10}
              onChange={handleSearch10}
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={ptechFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading10}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr. No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={150} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.P_Technique}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsPtech.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataPtech[rowData.id]?.PTechName || ''}
              //     onChange={value => handleInputChangePtech(rowData.id, 'PTechName', value)}
              //   />
              // ) : (
              rowData.attributes.PTechName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsPtech.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                  size="sm"
                  icon={<CheckIcon />}
                  active
                  onClick={() => handleSaveRowPtech(rowData.id)}
                  style={{ marginRight: '10px' }}
                /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowPtech(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelPtech}
                  // onClick={() =>
                  //   setEditedRowIdsPtech(prevRowIds =>
                  //     prevRowIds.filter(id => id !== rowData.id)
                  //   )
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowPtech(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue P_Technique"
                      description="Are you sure you want to continue this P_Technique?"
                      onConfirm={() => handlePtechc(rowData.id, rowData.attributes.PTechName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() =>
                        //   handlePtechc(rowData.id, rowData.attributes.PTechName)
                        // }
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue P_Technique"
                      description="Are you sure you want to discontinue this P_Technique?"
                      onConfirm={() => handlePtechD(rowData.id, rowData.attributes.PTechName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() =>
                        //   handlePtechD(rowData.id, rowData.attributes.PTechName)
                        // }
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p><small>Total row:{ptechFilterData.length}</small></p>
      </div>
    </>
  )
}

export default PTechNameMaster
